<template>
  <master-layout id="gpcrContentBookmark">
    <div
      class="mt-4 md:mt-8 md:mx-[72px] px-6 lg:w-3/4"
      :class="{ 'pt-12': isNativeNotWeb }"
    >
      <BackButton variant="inline" @click="back" />
      <div>
        <p
          class="font-aktiv-grotesk font-bold text-[20px] md:text-[24px] leading-[24px] md:leading-[32px] mt-6 mb-[16px]"
        >
          {{ $t("copy.resourcesPage.resourceSearch.bookmarksSection.header") }}
        </p>
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <div v-for="item in allResources">
          <div class="mt-[16px]">
            <ResourceCard
              v-for="(resource, index) in item.resources"
              :key="`${resource.slug}-${resource.type}`"
              :image-url="resource.thumbnail"
              :title="resource.title"
              :slug="resource.slug"
              :type="resource.type"
              :tag-slug="tagSlug"
              :duration="resource.duration"
              :is-exclusive="resource.isCVPExclusive"
              :is-audio="resource.isAudio"
              :avail-translations="resource.availTranslations"
              :resource-translations="resource.resourceTranslations"
              :isBookmarked="true"
              @openLanguageModal="openLanguageModal(index)"
            />
          </div>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapState } from "vuex"
import ResourceCard from "@/components/ResourcesPage/PlaybackResources/ResourceCard.vue"
import BackButton from "@/components/common/BackButton.vue"
import platformMixin from "@/mixins/platformMixin"
import { FirebaseAnalytics } from "@/utils/firebase-analytics-wrapper"
import { getCurrentLocale } from "@/utils/deviceLocale"
import { bookmark } from "ionicons/icons"

export default {
  name: "ResourceSearch",
  mixins: [platformMixin],
  components: {
    ResourceCard,
    BackButton,
  },
  data() {
    return {
      bookmarkIcon: bookmark,
    }
  },
  computed: {
    ...mapState("user", ["token"]),
    ...mapState("cms", ["sessionMaterials", "loading"]),
    ...mapState("filter", ["allResources"]),
  },
  async ionViewDidEnter() {
    const locale = await getCurrentLocale("Regional")
    FirebaseAnalytics.setScreenName({
      screenName: "resources - mylist",
      nameOverride: "ResourcesPage - Mylist",
    })
    await this.$store.dispatch("filter/fetchAllResources", {
      locale: locale,
      conferenceType: "Regional",
    })
  },
  async ionViewWillLeave() {},
  methods: {
    back() {
      this.$router.back()
    },
  },
}
</script>
<style scoped>
@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
